module.exports = __webpack_public_path__ + "static/img/brees-2014-top.dc18d75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-top.jpg
// module id = pdC0
// module chunks = 1